import { createClient } from '@supabase/supabase-js';

// Supabase configuration
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || 'https://wvsutsfhcrxfolxzaxvr.supabase.co';
const supabaseKey = process.env.REACT_APP_SUPABASE_ANON_KEY || 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Ind2c3V0c2ZoY3J4Zm9seHpheHZyIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDI4NzAzMzcsImV4cCI6MjA1ODQ0NjMzN30.hbGvh2c5ekLSj-Y4ahJ1HVKiOEk6o1A4CljBVGUlD1E';

// Create and export the Supabase client
export const supabase = createClient(supabaseUrl, supabaseKey, {
    auth: {
        detectSessionInUrl: true
    }
}); 
